import "../styles/Projects.scss";
import { content } from "../data/content";

const Projects = () => {
  return (
    <div className="projects">
      <section className="projects__hero">
        <h1>Projects</h1>
        <p>A collection of my side projects</p>
      </section>

      <div className="projects__grid">
        {content.projects.map((project, index) => (
          <div
            key={project.id}
            id={project.id}
            className="projects__card"
            tabIndex={0}
          >
            {project.image && (
              <div className="projects__image-container">
                <img src={project.image} alt={project.title} />
              </div>
            )}
            <div className="projects__content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="projects__technologies">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="projects__tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
              {project.link && (
                <a
                  href={project.link}
                  className="projects__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Project →
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
